import React from 'react';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const MoonpayButton = () => {
  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        MoonPay: Buy XRP and RLUSD with a credit card.&nbsp;
        <span className="small"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>
        Buy, store, and manage your XRP and RLUSD directly within your MoonPay account.
        In partnership with Ripple. Your one-stop shop for the XRP ecosystem.
      </Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href="https://api.xrpscan.com/api/v1/campaign/moonpaybutton"
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >Buy XRP with Credit Card</Button>
        </OverlayTrigger>
    </span>
  )
}

export default MoonpayButton;